import { palette, SpacedGroup, Tooltip } from '@versionone/components';
import { Playground } from '@versionone/doc-components';
import * as AllIcons from '@versionone/icons';
import * as React from 'react';
export default {
  palette,
  SpacedGroup,
  Tooltip,
  Playground,
  AllIcons,
  React
};